import React from "react";
import "./PageNavigationItem.scss";

interface PageNavigationItemProps {
  id: string;
  label: string;
  href: string;
  active?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>,id: string) => void;
}

const PageNavigationItem = ({ id, label, href, active, onClick }: PageNavigationItemProps) => {
  const onClickItem = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick(e, id);
    }
  }

  return (
    <a href={href} className={`page-navigation-item ${active ? 'page-navigation-item--active' : ''}`} onClick={onClickItem}>
      {label}
    </a>
  );
};

export default PageNavigationItem;
